export const BookingStatus = {
    ATTENDING: 'ATTENDING',
    ATTENDED: 'ATTENDED',
    UNATTENDED: 'UNATTENDED'
}